import Text from 'components/Text/Text';
import React from 'react';
import { Link } from 'react-router-dom';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import { useRoleAccess } from 'hooks/useRoleAccess';
import { UserRoles } from 'types';
import style from './GamesCategoriesBtn.module.scss';

const GamesCategoriesBtn: React.FC = () => {
	const hasAccess = useRoleAccess([UserRoles.SUPER_USER, UserRoles.TECHNICAL]);

	return (
		<Link
			className={style.container}
			to={`/entertainment/games${hasAccess ? '/categories' : ''}`}
			data-test="GamesCategoriesBtn">
			<Button
				className={style.button}
				theme="primaryBlue"
				icon={
					<svg className={style.icon}>
						<use xlinkHref={`${breadcrumbs}#changePosition`} />
					</svg>
				}
				disabled={!hasAccess}>
				<Text translationNameSpace="listing" translationKey="gameCategoriesButton" asFragment={true} />
			</Button>
		</Link>
	);
};

export default GamesCategoriesBtn;
